import type { AgencyCreate } from '@/modules/agencies/types/agency'
import type { AgencyFormFieldErrors } from '@/modules/agencies/types/agencyForm'

const SLUG_PATTERN = /^[a-z0-9]+(?:-[a-z0-9]+)*$/

type ValidationResult =
  | { ok: true; value: AgencyCreate }
  | { ok: false; fieldErrors: AgencyFormFieldErrors }

export function validateAgencyCreate(fields: {
  name: string
  slug: string
}): ValidationResult {
  const name = fields.name.trim()
  const slug = fields.slug.trim().toLowerCase()
  const fieldErrors: AgencyFormFieldErrors = {}

  if (!name) {
    fieldErrors.name = 'Name is required.'
  } else if (name.length < 2) {
    fieldErrors.name = 'Name must be at least 2 characters.'
  }

  if (!slug) {
    fieldErrors.slug = 'Slug is required.'
  } else if (!SLUG_PATTERN.test(slug)) {
    fieldErrors.slug =
      'Use lowercase letters, numbers, and hyphens only (e.g. northwind-agency).'
  }

  if (Object.keys(fieldErrors).length > 0) {
    return { ok: false, fieldErrors }
  }

  return { ok: true, value: { name, slug } }
}
